import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminService from "../admin/adminService";
import studentService from "./studentService";

const initialState = {
  student: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//Create new student
export const addStudent = createAsyncThunk(
  "student/create",
  async (studentData, thunkAPI) => {
    try {
      return await studentService.addStudent(studentData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

//Edit student
export const editStudent = createAsyncThunk(
  "student/edit",
  async (studentData, thunkAPI) => {
    try {
      return await studentService.editStudent(studentData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

// Get user students
export const getStudent = createAsyncThunk(
  "student/getOne",
  async (student_id, thunkAPI) => {
    try {
      const getStudentSeviceResponse = await studentService.getStudent(
        student_id
      );
      return getStudentSeviceResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

// Get user students
export const getStudents = createAsyncThunk(
  "students/getAll",
  async (thunkAPI) => {
    try {
      return await studentService.getStudents();
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

// Delete user student
export const deleteStudent = createAsyncThunk(
  "student/delete",
  async ({ id }, thunkAPI) => {
    try {
      return await studentService.deleteStudent(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const getStudentWeekWise = createAsyncThunk(
  "student/admin/get",
  async (data, thunkAPI) => {
    try {
      const getStudentSeviceResponse = await adminService.getStudentWeekWise(
        data.params
      );
      return getStudentSeviceResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const unBlockSlot = createAsyncThunk(
  "student/unblockslot/get",
  async (student_id, thunkAPI) => {
    try {
      const getStudentSeviceResponse = await adminService.unBlockSlotForBooking(
        student_id
      );
      return getStudentSeviceResponse;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const studentSlice = createSlice({
  name: "student",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addStudent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student.push(action.payload);
      })
      .addCase(addStudent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.errorMessage;
        state.error = action.payload;
      })
      .addCase(editStudent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(editStudent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.errorMessage;
        state.error = action.payload;
      })
      .addCase(getStudent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student = action.payload;
      })
      .addCase(getStudent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.errorMessage;
        state.error = action.payload;
      })
      .addCase(getStudents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStudents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student = action.payload;
      })
      .addCase(getStudents.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.errorMessage;
        state.error = action.payload;
      })
      .addCase(deleteStudent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteStudent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student = state.student.filter(
          (student) => student.student_id !== action.payload.id
        );
      })
      .addCase(deleteStudent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.errorMessage;
        state.error = action.payload;
      })
      .addCase(getStudentWeekWise.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStudentWeekWise.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student = action.payload.recordset;
      })
      .addCase(getStudentWeekWise.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      .addCase(unBlockSlot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(unBlockSlot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.student = action.payload.recordset;
      })
      .addCase(unBlockSlot.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      });
  },
});

export const { reset } = studentSlice.actions;
export default studentSlice.reducer;
